import { render, staticRenderFns } from "./BoardsView.vue?vue&type=template&id=1460c1b0"
import script from "./BoardsView.vue?vue&type=script&lang=js"
export * from "./BoardsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports